import { mapResponse200, mapResponse400 } from './mappers';
import { fetchShowBlackFridayEtazhi } from 'shared/repositories/mortgage-subsidised-offers/v1/show-black-friday-etazhi';
import {
  selectEtazhiBlackFridayPromoOffersData,
  selectIsEtazhiBlackFridayEnabled,
} from 'shared/selectors/etazhiBlackFriday';
import { getIsFlatSale, getIsRoomSale, getIsStartDatePassed } from 'shared/utils/etazhiBlackFriday';

import type { TJsonQuery } from '../../../packages/JsonQuery';
import type { IAppState } from 'shared/common/state';
import type { IApplicationContext } from 'shared/types/applicationContext';

interface IParams {
  context: IApplicationContext;
  parameters: {
    regionId: number;
    jsonQuery: TJsonQuery;
    getState: () => IAppState;
  };
}

export const fetchEtazhiBlackFridayShowByRegion = async ({ context, parameters }: IParams) => {
  const { getState, jsonQuery, regionId } = parameters;

  const state = getState();

  const isEnabled = selectIsEtazhiBlackFridayEnabled(state);
  const etazhiPromoOffersData = selectEtazhiBlackFridayPromoOffersData(state);

  /**
   * Выключена РСка всего проекта
   */
  if (!isEnabled) {
    return false;
  }

  const isStartDatePassed = getIsStartDatePassed(etazhiPromoOffersData);

  /**
   * Включена РСка компонента "Промо-полки", но дата старта
   * промо-кампании ещё не наступила
   */
  if (!isStartDatePassed) {
    return false;
  }

  const isFlatSale = getIsFlatSale(jsonQuery);
  const isRoomSale = getIsRoomSale(jsonQuery);

  /**
   * Неподходящая категория недвиж. и тип сделки
   */
  if (!isFlatSale && !isRoomSale) {
    return false;
  }

  try {
    const mappers = {
      200: mapResponse200,
      400: mapResponse400,
    };

    const result = await fetchShowBlackFridayEtazhi({ httpApi: context.httpApi, parameters: { regionId }, mappers });

    return Boolean(result);
  } catch {
    return false;
  }
};
